import { getIdToken } from '../../../src/contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../../../src/config/api';

const REQUEST_TIMEOUT_MS = 15000;

export async function fetchSnowData(endpoint, signal) {
  const controller = new AbortController();
  const cancel = () => controller.abort(signal.reason);
  if (signal?.aborted) cancel();
  else signal?.addEventListener('abort', cancel, { once: true });
  const timeout = setTimeout(() => controller.abort(new Error('REKKIE Snow took too long to respond. Please retry.')), REQUEST_TIMEOUT_MS);
  let onAbort;
  const aborted = new Promise((resolve, reject) => {
    onAbort = () => reject(controller.signal.reason);
    if (controller.signal.aborted) onAbort();
    else controller.signal.addEventListener('abort', onAbort, { once: true });
  });
  try {
    const request = async () => {
      const token = await getIdToken();
      controller.signal.throwIfAborted();
      if (!token) throw new Error('Please sign in to view REKKIE Snow.');
      const response = await fetch(buildApiUrl(`/rekkie-snow/${endpoint}`), {
        headers: getAuthHeaders(token), signal: controller.signal,
      });
      if (!response.ok) throw new Error(`REKKIE Snow could not load (${response.status}).`);
      return response.json();
    };
    // Token refresh and response decoding must also respect the deadline.
    return await Promise.race([request(), aborted]);
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener('abort', cancel);
    controller.signal.removeEventListener('abort', onAbort);
  }
}
